/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Onofftogglesnumber3Inputs */



/**
* | output |
* | --- |
* | "On/off toggle count" |
*
* @param {Ahu_History_Key_Onofftogglesnumber3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_onofftogglesnumber3 = /** @type {((inputs?: Ahu_History_Key_Onofftogglesnumber3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Onofftogglesnumber3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("On/off toggle count")
	return /** @type {LocalizedString} */ ("Nombre de basculements marche/arrêt")
});
export { ahu_history_key_onofftogglesnumber3 as "ahu_history_key_onOffTogglesNumber" }